export { default as TabHeaderPart } from './Part.tab';
export { default as TabHeaderUse } from './Use.tab';
